import { c as _c } from "react/compiler-runtime";
import { Badge } from "@/components/ui/Badge";
import { Card } from "@/components/ui/Card/Card";
import { Heading } from "@/components/ui/Heading";
import { Image } from "@/components/ui/Image";
import { Progress } from "@/components/ui/Progress";
import type { ReactNode } from "react";

// A goal card: cover image, title, an achieved/total count and a progress bar.
export function CardProgress(t0) {
  const $ = _c(26);
  const {
    title,
    progressAchieved,
    progressTotal,
    completedText,
    coverImageUrl,
    unitLabel: t1,
    action
  } = t0;
  const unitLabel = t1 === undefined ? "Placements" : t1;
  let t2;
  if ($[0] !== completedText) {
    t2 = completedText && <span className="absolute right-2 top-2 z-10"><Badge color="info">{completedText}</Badge></span>;
    $[0] = completedText;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== coverImageUrl || $[3] !== title) {
    t3 = coverImageUrl ? <div className="relative h-40 w-full"><Image src={coverImageUrl} alt={title} className="object-cover" fill={true} sizes="(max-width: 768px) 100vw, 33vw" unoptimized={true} /></div> : <div className="h-40 w-full bg-bg-primary" />;
    $[2] = coverImageUrl;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <Heading level={3} weight="medium">{title}</Heading>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = progressTotal === null ? "" : `/${progressTotal}`;
  let t6;
  if ($[7] !== progressAchieved || $[8] !== t5 || $[9] !== unitLabel) {
    t6 = <span className="text-base text-text-tertiary">{progressAchieved}{t5} {unitLabel}</span>;
    $[7] = progressAchieved;
    $[8] = t5;
    $[9] = unitLabel;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className="flex flex-row items-center justify-between gap-3">{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = progressTotal === null ? 100 : progressAchieved / progressTotal * 100;
  let t9;
  if ($[14] !== t8) {
    t9 = <Progress value={t8} />;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== action) {
    t10 = action && <div className="pt-1">{action}</div>;
    $[16] = action;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t9) {
    t11 = <div className="flex flex-col gap-2 px-4 pb-4 pt-3">{t7}{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t9;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t2 || $[24] !== t3) {
    t12 = <Card className="relative min-h-60">{t2}{t3}{t11}</Card>;
    $[22] = t11;
    $[23] = t2;
    $[24] = t3;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}